import { useParams } from "@tanstack/react-router";
import { getQueryOptions, ResponseForPath } from "../../../../../lib/api";
import { useQuery } from "@tanstack/react-query";

export const useTestScanPages = () => {
  const params = useParams({
    from: "/$test-slug/groups/$id/review/",
  });
  const testScanPagesQuery = useQuery(
    getQueryOptions({
      endpoint: "/groups/:id/test-scan-pages",
      pathParams: {
        id: params.id,
      },
      queryParams: {
        isGraded: "true",
      },
    })
  );

  return testScanPagesQuery;
};

export const useGroupQuery = () => {
  const params = useParams({
    from: "/$test-slug/groups/$id/review/",
  });
  return useQuery(
    getQueryOptions({
      endpoint: "/groups/:id",
      pathParams: {
        id: params.id,
      },
    })
  );
};

export type Scan = ResponseForPath<
  "/groups/:id/test-scan-pages",
  "get"
>["data"][number];
